module.exports = __webpack_public_path__ + "static/media/febracis.199e2f90.svg";